import SearchIcon from '@mui/icons-material/Search'
import IconButton from '@mui/material/IconButton'
import InputAdornment from '@mui/material/InputAdornment'
import TextField from '@mui/material/TextField'
import React, { ChangeEvent } from 'react'

type SearchComponentProps = {
  onSearchChange: (value: string) => void
  onSearchClick: () => void
}

const SearchComponent: React.FC<SearchComponentProps> = ({
  onSearchChange,
  onSearchClick,
}) => {
  return (
    <TextField
      size='small'
      variant='outlined'
      placeholder='Search...'
      label='Search'
      onChange={(e: ChangeEvent<HTMLInputElement>) =>
        onSearchChange(e.target.value)
      }
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton onClick={onSearchClick}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default SearchComponent
